import { useEffect, useState } from "react";
import { adminApi } from "@/admin/AdminAuthContext";
import AdminPageShell from "@/admin/AdminPageShell";
import { VENTURES } from "@/data/ventures";

const AdminBrands = () => {
  const [statusMap, setStatusMap] = useState({});
  const [loading, setLoading] = useState(true);

  const load = () => adminApi.get("/brands").then((res) => {
    const map = {};
    res.data.forEach((b) => { map[b.slug] = b; });
    setStatusMap(map);
  }).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const update = async (slug, field, value) => {
    const current = statusMap[slug] || {};
    const updated = { ...current, [field]: value };
    setStatusMap({ ...statusMap, [slug]: updated });
    await adminApi.put(`/brands/${slug}`, updated);
  };

  return (
    <AdminPageShell title="Brands" description="Live brand content and copy are managed in the codebase for performance and reliability. This module tracks operational status and internal notes for the team." testId="admin-brands-page">
      {loading ? <p className="text-small">Loading…</p> : (
        <div className="space-y-4">
          {VENTURES.map((v) => {
            const s = statusMap[v.slug] || {};
            return (
              <div key={v.slug} className="neu-surface p-6" data-testid={`admin-brand-${v.slug}`}>
                <div className="flex items-center justify-between mb-4 flex-wrap gap-3">
                  <h3 className="text-h4">{v.name}</h3>
                  <select value={s.status || "Coming Soon"} onChange={(e) => update(v.slug, "status", e.target.value)} className="neu-inset h-10 px-3" data-testid={`admin-brand-status-${v.slug}`}>
                    <option value="Coming Soon">Coming Soon</option>
                    <option value="Live">Live</option>
                  </select>
                </div>
                <textarea
                  placeholder="Internal notes"
                  value={s.notes || ""}
                  onChange={(e) => update(v.slug, "notes", e.target.value)}
                  className="neu-inset w-full p-3"
                  rows={2}
                  data-testid={`admin-brand-notes-${v.slug}`}
                />
              </div>
            );
          })}
        </div>
      )}
    </AdminPageShell>
  );
};

export default AdminBrands;
